import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=064b583f&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=064b583f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b583f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064b583f')) {
      api.createRecord('064b583f', component.options)
    } else {
      api.reload('064b583f', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=064b583f&scoped=true&", function () {
      api.rerender('064b583f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d0N34zD16KPB/JS/comp/Paginate.vue"
export default component.exports